import { Link } from 'react-router-dom';
import { Building2, Globe2, Wallet } from 'lucide-react';

const contactDetails = [
  ['Bedrijfsnaam', 'Buybeez'],
  ['Merk / dienst', 'budgettoppers'],
  ['Land', 'Nederland'],
  ['E-mail', 'budgettoppers@buybeez.nl'],
  ['KvK-nummer', '92484476'],
  ['BTW-nummer', 'NL004956879B14'],
  ['D-U-N-S-nummer', '494977417'],
];

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-white/95 backdrop-blur">
        <div className="mx-auto flex max-w-5xl items-center justify-between gap-4 px-4 py-4 sm:px-6 sm:py-5">
          <Link to="/" className="flex items-center gap-3 text-foreground">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary text-primary-foreground">
              <Wallet className="h-5 w-5" />
            </div>
            <span className="font-heading text-lg font-bold">budgettoppers</span>
          </Link>
          <Link to="/" className="shrink-0 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground">
            Terug naar home
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-8 sm:px-6 sm:py-12">
        <div className="mb-6 flex items-start gap-4 rounded-3xl border border-border bg-white p-6 shadow-card sm:mb-10 sm:p-8">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <Building2 className="h-6 w-6" />
          </div>
          <div className="min-w-0">
            <p className="mb-2 text-sm font-semibold uppercase tracking-[0.2em] text-primary">Contact</p>
            <h1 className="font-heading text-3xl font-bold leading-tight text-foreground sm:text-4xl">Contact en bedrijfsgegevens</h1>
            <p className="mt-3 max-w-2xl text-base leading-7 text-muted-foreground">
              Voor vragen over budgettoppers, privacy, voorwaarden of zakelijke gegevens kun je deze bedrijfsgegevens
              gebruiken als referentie.
            </p>
          </div>
        </div>

        <div className="grid gap-6 lg:grid-cols-[1.7fr_1fr] lg:items-start">
          <section className="rounded-3xl border border-border bg-white p-6 shadow-card sm:p-8">
            <h2 className="font-heading text-xl font-semibold leading-tight sm:text-2xl">Zakelijke identificatie</h2>
            <div className="mt-6 grid gap-3">
              {contactDetails.map(([label, value]) => (
                <div key={label} className="rounded-2xl border border-border bg-muted/20 px-4 py-4 text-left">
                  <p className="text-xs uppercase tracking-[0.14em] text-muted-foreground">{label}</p>
                  <p className="mt-1 break-words text-sm font-medium leading-6 text-foreground">{value}</p>
                </div>
              ))}
            </div>
          </section>

          <aside className="rounded-3xl border border-border bg-muted/30 p-5 sm:p-6">
            <div className="rounded-2xl border border-border bg-white p-5">
              <div className="flex items-center gap-3">
                <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-primary/10 text-primary">
                  <Globe2 className="h-5 w-5" />
                </div>
                <div>
                  <p className="font-heading text-lg font-semibold">budgettoppers</p>
                  <p className="text-sm text-muted-foreground">Dienst van Buybeez</p>
                </div>
              </div>
              <p className="mt-4 text-sm leading-7 text-muted-foreground">
                Gebruik voor formele bedrijfsverificatie de bovenstaande KvK-, btw- en D-U-N-S-gegevens. Voor
                juridische pagina’s zie ook de privacyverklaring en voorwaarden.
              </p>
              <div className="mt-5 space-y-2 text-sm">
                <Link to="/privacy" className="block font-medium text-primary hover:underline">
                  Naar privacyverklaring
                </Link>
                <Link to="/voorwaarden" className="block font-medium text-primary hover:underline">
                  Naar voorwaarden
                </Link>
              </div>
            </div>
          </aside>
        </div>
      </main>
    </div>
  );
}
